__turbopack_context__.v({
  "img": "style-module-scss-module__Lzhc7a__img",
  "slide": "style-module-scss-module__Lzhc7a__slide",
  "swiper": "style-module-scss-module__Lzhc7a__swiper",
});
